import { getLandingSource } from './landingAttribution'
import './metaAttribution'
import { agentCodeFromUrl, getInitAgentCode, hasPersistedInitAgentCode, isPwaLaunch, restorePwaLaunchAgentCode } from './initAgentCode'

// Module loading precedes the application's router and initialization requests.
restorePwaLaunchAgentCode()

// Keep the init attribution separate from the registration form state.
export const getAgentCode = ({ commit, state }) => {
  let legacyCode = state.registerAgentCode
  try { legacyCode = legacyCode || window.sessionStorage.getItem('registerAgentCode') } catch (e) {}
  const source = getLandingSource()
  const initCode = getInitAgentCode(legacyCode || (source && source.agentCode))
  const agentCode = agentCodeFromUrl() || (source && source.agentCode === initCode ? initCode : '')
  if (agentCode) commit('setRegisterAgentCode', agentCode)
  return initCode
}

// 初始化code
export const initAgentCode = (that, objName = 'ruleForm', keyName = "agentCode") => {
  let savedCode = ''
  try { savedCode = window.sessionStorage.getItem('registerAgentCode') } catch (e) {}
  const source = getLandingSource()
  let agentCode = agentCodeFromUrl() || getInitAgentCode(savedCode || (source && source.agentCode))
  if (!agentCode) {
    if (that.$store.state.registerAgentCode) that.$set(that[objName], keyName, that.$store.state.registerAgentCode)
  } else {
    that.$set(that[objName], keyName, agentCode)
    that.$store.commit('setRegisterAgentCode', agentCode)
  }
}

export const setAgentCode = (store) => {
  const href = window.location.href
  if (!/[?&]agentCode=/.test(href)) return
  const agentCode = getAgentCode(store)
  if (isPwaLaunch() || getLandingSource()) return // Desktop launches must stay on home even after landing metadata expires.
  const path = href.indexOf('/newregister') !== -1 ? '/newregister' : '/register'
  const target = window.__metaAttribution.redirectUrl(window.location.origin + path, hasPersistedInitAgentCode(agentCode))
  if (target !== href) window.location.replace(target)
}



// WEBPACK FOOTER //
// ./src/common/utils/initRegisterAgentCode.js